import { BudgetHistoryType } from "~frontend/__generated__/graphql";

import { formatMillicentsAsDollars } from "../pricing/priceFormatting";
import { Budget } from "./types";

export function budgetIsActive(budget: Budget): boolean {
  if (!budget.history.length) {
    // this should never happen
    return false;
  }

  if (budget.endDate && budget.endDate < new Date()) {
    return false;
  }

  const lastBudgetModification = budget.history[budget.history.length - 1];
  if (lastBudgetModification.type === BudgetHistoryType.BudgetEnded) {
    return false;
  }

  return true;
}

export function formatMaybeNegativeMillicentsAsDollarsWithDollarSign(
  millicents: number
): string {
  if (millicents < 0) {
    return `-$${formatMillicentsAsDollars(-1 * millicents)}`;
  } else {
    return `$${formatMillicentsAsDollars(millicents)}`;
  }
}
